import React from "react";

import SiteFooter from "components/site/SiteFooter";
import SiteNavbar from "components/site/SiteNavbar";
import useBodyClass from "hooks/useBodyClass";

function SiteShell({ children, pageClassName = "ignitum-site-page" }) {
  useBodyClass(pageClassName);

  return (
    <div className="ignitum-site-shell">
      <SiteNavbar />
      <main className="site-main">{children}</main>
      <SiteFooter />
    </div>
  );
}

export default SiteShell;
